import { NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { AddonsPageModule } from 'src/app/components/addons-page/addons-page.module';
import {
  ActionableItemComponent,
  AddCreditCardItemComponent,
  BillingDetailBaseItemComponent
} from 'src/app/components/new-billing/billing-detail-items';
import { BillingDetailsComponent } from 'src/app/components/new-billing/billing-details/billing-details.component';
import {
  BillingLogosSectionComponent
} from 'src/app/components/new-billing/billing-logos-section/billing-logos-section.component';
import { BillDetailsRowComponent } from 'src/app/components/new-billing/checkout-v2/bill-details-row/bill-details-row.component';
import {
  ChoosePlanGenericComponent
} from 'src/app/components/new-billing/choose-plan-generic/choose-plan-generic.component';
import { ChoosePlanComponent } from 'src/app/components/new-billing/choose-plan/choose-plan.component';
import { PaymentSummaryComponent } from 'src/app/components/new-billing/payment-summary/payment-summary.component';
import {
  UpcomingInvoicePreviewComponent
} from 'src/app/components/new-billing/upcoming-invoice-preview/upcoming-invoice-preview.component';
import {
  UpgradeDowngradePlanComponent
} from 'src/app/components/new-billing/upgrade-downgrade-plan/upgrade-downgrade-plan.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { BillingPlansSectionComponent } from 'src/app/pages/new-billing/billing-plans-section/billing-plans-section.component';
import { UpgradeBillingDetailsComponent } from 'src/app/pages/new-billing/upgrade-billing-details/upgrade-billing-details.component';
import { ContactSalesModule } from '../contact-sales/contact-sales.module';
import { BillingCalculatorComponent } from './billing-calculator/billing-calculator.component';
import { CheckoutV2Component } from './checkout-v2/checkout-v2.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { ChoosePlanButtonsComponent } from './choose-plan-buttons/choose-plan-buttons.component';
import { HeaderUpgradePlanDialogComponent } from './header-upgrade-plan-dialog/header-upgrade-plan-dialog.component';
import { IntegrationsUpsellComponent } from './integrations-upsell/integrations-upsell.component';
import { PaymentRecurrenceTabsComponent } from './payment-recurrence-tabs/payment-recurrence-tabs.component';
import { PlanCardComponent } from './plan-card/plan-card.component';
import { PlanComparisonComponent } from './plan-comparison/plan-comparison.component';
import { PriceSectionComponent } from './price-section/price-section.component';
import { PricingFaqsWidgetModule } from './pricing-faqs-widget/pricing-faqs-widget.module';
import { SubscriptionStatusBadgeModule } from './subscription-status-badge/subscription-status-badge.module';
const components = [
  ActionableItemComponent,
  AddCreditCardItemComponent,
  BillingDetailBaseItemComponent,
  BillingDetailsComponent,
  ChoosePlanGenericComponent,
  BillDetailsRowComponent,
  PlanCardComponent,
  CheckoutComponent,
  CheckoutV2Component,
  ChoosePlanComponent,
  UpgradeDowngradePlanComponent,
  PaymentSummaryComponent,
  UpcomingInvoicePreviewComponent,
  BillingLogosSectionComponent,
  BillingPlansSectionComponent,
  PlanComparisonComponent,
  PaymentRecurrenceTabsComponent,
  PriceSectionComponent,
  ChoosePlanButtonsComponent,
  UpgradeBillingDetailsComponent,
  BillingCalculatorComponent,
  IntegrationsUpsellComponent,
  HeaderUpgradePlanDialogComponent,
];

@NgModule({
  declarations: [
    ...components,
  ],
  imports: [
    AddonsPageModule,
    MatRadioModule,
    SharedModule,
    MatSlideToggleModule,
    MatTableModule,
    NgOptimizedImage,
    ContactSalesModule,
    SubscriptionStatusBadgeModule,
    PricingFaqsWidgetModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSortModule,
    TranslateModule,
  ],
  exports: [
    ...components,
  ],
})
export class NewBillingComponentsModule {
  constructor(
    matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
    this.registerIcons(matIconRegistry);
  }

  private registerIcons(matIconRegistry: MatIconRegistry) {
    matIconRegistry
      .addSvgIconInNamespace('cards', 'american_express', this.setIcon('amex.svg'))
      .addSvgIconInNamespace('cards', 'diners_club', this.setIcon('diners.svg'))
      .addSvgIconInNamespace('cards', 'discover', this.setIcon('discover.svg'))
      .addSvgIconInNamespace('cards', 'jcb', this.setIcon('jcb.svg'))
      .addSvgIconInNamespace('cards', 'mastercard', this.setIcon('mastercard.svg'))
      .addSvgIconInNamespace('cards', 'union_pay', this.setIcon('union-pay.svg'))
      .addSvgIconInNamespace('cards', 'visa', this.setIcon('visa.svg'))
      .addSvgIconInNamespace('cards', 'visa_no_border', this.setIcon('visa_no_border.svg'))
      .addSvgIconInNamespace('cards', 'american_express_no_border', this.setIcon('american_express_no_border.svg'))
      .addSvgIconInNamespace('cards', 'diners_club_no_border', this.setIcon('diners_club_no_border.svg'))
      .addSvgIconInNamespace('cards', 'discover_no_border', this.setIcon('discover_no_border.svg'))
      .addSvgIconInNamespace('cards', 'jcb_no_border', this.setIcon('jcb_no_border.svg'))
      .addSvgIconInNamespace('cards', 'mastercard_no_border', this.setIcon('master_card_no_border.svg'))
      .addSvgIconInNamespace('cards', 'union_pay_no_border', this.setIcon('union_pay_no_border.svg'))
      .addSvgIconInNamespace('cards', 'no_card', this.setIcon('no-card.svg'))
      .addSvgIconInNamespace('cards', 'unknown', this.setIcon('unknown.svg'))
      .addSvgIconInNamespace('billing', 'check_circle_twotone_blue', this.setIcon('check_circle_twotone_blue.svg'))
      .addSvgIconInNamespace('billing', 'report_problem_twotone_blue', this.setIcon('report_problem_twotone_blue.svg'))
      .addSvgIcon(
        'credit_card_neutral',
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/billing/credit_card_neutral.svg'),
      )
      .addSvgIcon(
        'remove_circle_neutral',
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/billing/remove_circle_neutral.svg'),
      )
      .addSvgIcon(
        'event_neutral',
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/billing/event_neutral.svg'),
      );
  }

  private setIcon(iconName: string) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/images/subscribe-plans/${iconName}`);
  }
}
